import { z } from 'zod';
export const GoogleCalendarConnection = z
    .object({
    configured: z.boolean(),
    connected: z.boolean(),
    accountEmail: z.string().nullable(),
    calendarName: z.string().nullable(),
    calendarUrl: z.url().nullable(),
    needsReconnect: z.boolean(),
    callbackUrl: z.url().nullable(),
    pendingCount: z.number().int().nonnegative().default(0),
    errorCount: z.number().int().nonnegative().default(0),
})
    .strict();
export const GoogleCalendarConnectionResponse = z
    .object({ connection: GoogleCalendarConnection })
    .strict();
export const GoogleCalendarConnectResponse = z.object({ authorizationUrl: z.url() }).strict();
export const GoogleCalendarCallbackRequest = z
    .object({ code: z.string().min(1).max(8192), state: z.string().min(32).max(128) })
    .strict();
export const GoogleCalendarShootResponse = z
    .object({
    state: z.enum([
        'NotConnected',
        'NotScheduled',
        'MissingTime',
        'Ready',
        'Pending',
        'Synced',
        'Error',
    ]),
    eventUrl: z.url().nullable(),
    lastSyncedAt: z.iso.datetime().nullable(),
})
    .strict();
